var path = '/opt/atlassian/pipelines/agent/build/src/app/components/timeline/timeline-main/timeline-main.html';
var html = " <ng-include ng-if=$ctrl.displayPage1 src=$ctrl.timelineTemplate1Url></ng-include> <timeline-multiple-questions ng-if=$ctrl.displayPage2 location-list=$ctrl.locationList details=$ctrl.details , is-added={{$ctrl.isAdded}} main-event-details=$ctrl.details on-go-back=$ctrl.onGoBack($locals) on-cancel=$ctrl._onCancel() disable-buttons=$ctrl.disableButtons on-submit=$ctrl._onSubmit($event)> </timeline-multiple-questions>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/timeline/timeline-main/timeline-main.html
// module id = 982
// module chunks = 0